import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    CardText,
    CardFooter,
    Container,
} from "reactstrap";
import compass from "../image/New Stud Dash/career-exploration.webp";
import assessment from "../image/proficiency.png";
import session_icon from '../image/New Stud Dash/training.png';
import admissions from '../image/New Stud Dash/document.png';
import parent_call from '../image/New Stud Dash/communication.png';
// import report from "../image/New Stud Dash/career-report.png";
import counseller from "../image/New Stud Dash/career-counselling.webp";
import call from "../image/New Stud Dash/phone.png";
import Lock from "../image/New Stud Dash/lock.webp";
import kncow_image from '../image/New Stud Dash/know.webp';
import career_image from '../image/New Stud Dash/advancement.webp';
import admission_image from '../image/New Stud Dash/paper.webp';
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import '../Css/Contact.css';
import Outcome from "../image/New Stud Dash/outcome.webp";
import { MdArrowRightAlt } from "react-icons/md";
import GetStarted from "../component/GetStarted";
const buttons = [
    "pl_Q53v9fnjNem13E",
    "pl_QDOG1NvcLtzOff",
    "pl_Q54cTIF8noZAar",
    "pl_Q54dlH0xgZvd4t",
];
const PricingPlan = () => {
    const [activeTab, setActiveTab] = useState("");
    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };
    // payment
    useEffect(() => {
        buttons.forEach((id, index) => {
            const form = document.getElementById(`razorpay-form-${index}`);
            if (form && !form.querySelector("script")) { // Prevent multiple scripts
                const script = document.createElement("script");
                script.src = "https://checkout.razorpay.com/v1/payment-button.js";
                script.dataset.payment_button_id = id;
                script.async = true;
                form.appendChild(script);
            }
        });

        // Cleanup Function (Remove Scripts on Unmount)
        return () => {
            buttons.forEach((id, index) => {
                const form = document.getElementById(`razorpay-form-${index}`);
                if (form) {
                    form.innerHTML = "";
                }
            });
        };
    }, []);

    return (
        <>
            {/* hero sections */}
            <Container fluid style={{ background: '#1E2538' }} className="hero_all overflow-hidden">
                <Row className="justify-content-center">
                    <Col xl="12">
                        <div class="header_banner align-self-center  text-center pt-0">
                            <br />
                            <div className="main_part positions-relative">
                                <div className="fs-3  head_text text-white">Afforadable </div>
                                <h1 class="fw-bold h1_title">Pricing - Plan</h1>
                            </div>
                            <br />
                        </div>
                    </Col>
                </Row>
            </Container>
            {/* pricing */}
            <Container fluid>
                <Row className="justify-content-center pt-4">
                    <Col xs="12" lg="12" xl="12" xxl="8">
                        <Row className="d-flex justify-content-center programs rounded-4  pt-5 g-am-0 g-4">
                            <Col className="mb-2" xs="12">
                                <div className="centerAlign">
                                    <div className="row p-sm-5 p-3">
                                        <div className="borderr col-lg-8 my-auto ">
                                            <h3>Career Selection Kit</h3>
                                            <p>Our expert career advisors will assess your current standing and guide you towards the next steps, empowering you to plan your career strategically and turn your dreams and aspirations into reality.</p>
                                        </div>
                                        <div class="col-lg-4 text-center">
                                            <h2 className="fw-semibold">
                                                <small className="align-top fw-semibold">Rs</small> <span className="fw-semibold">1100/-</span>
                                                <div className="align-bottom fw-semibold">Per Student</div>
                                            </h2>

                                            <div className="d-flex justify-content-center"> <br />
                                                <div className="d-flex justify-content-between align-items-sm-start align-items-center">
                                                    <div className="razorpay-button-container">
                                                        <form id="razorpay-form-1">
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col xl="4" sm="10" md="6" lg="4" className="pointer">
                                <Card onClick={() => toggle(1)} className={`h-100 ${activeTab === 1 ? "active-tab" : ""}`}>
                                    <CardBody>
                                        <CardTitle
                                            tag="h5"
                                            className="box-header-style text-center pb-3 border-bottom"
                                        >
                                            Know Your Self
                                        </CardTitle>
                                        <div className="justify-content-center mb-4 d-flex">
                                            <CardText
                                                className="fw-semibold align-self-center"
                                                tag="h3"
                                            >
                                                Rs 2100
                                            </CardText>
                                            <img className="ms-4" height={60} width={60} alt="know_image" src={kncow_image} />
                                        </div>
                                        <div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={compass}
                                                        alt="compass"
                                                        width={25}
                                                        height={25}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 pricing_title  fw-semibold"
                                                    >
                                                        Career Exploration
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    Access well-researched content on careers, colleges,
                                                    courses, exams & scholarships
                                                </p>
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={assessment}
                                                        alt="compass"
                                                        width={25}
                                                        height={25}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 pricing_title fw-semibold"
                                                    >
                                                        Career Assessment
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    3-dimensional assessment covering 16 factors in
                                                    Aptitude, Personality & Interest
                                                </p>
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={session_icon}
                                                        alt="compass"
                                                        width={25}
                                                        height={25}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 pricing_title fw-semibold"
                                                    >
                                                        5 Live Weekly Career Class
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    Weekly live group class by top industry
                                                    professionals & college alumni
                                                </p>
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={call}
                                                        alt="compass"
                                                        width={25}
                                                        height={25}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 pricing_title fw-semibold"
                                                    >
                                                        1 Follow-Up Call
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    30-min session or call to answer your queries
                                                </p>
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={parent_call}
                                                        alt="compass"
                                                        width={35}
                                                        height={35}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 pricing_title fw-semibold"
                                                    >
                                                        15-Min Parent Guidance Call
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    Discuss career options with an expert
                                                </p>
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={Lock}
                                                        alt="compass"
                                                        width={25}
                                                        height={25}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 fw-semibold"
                                                        style={{ color: "#314862" }}
                                                    >
                                                        1-on-1 Expert Career Session
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    One counselling session of 45 minutes to help in
                                                    understanding yourself & suitable career pathways
                                                </p>
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={Lock}
                                                        alt="compass"
                                                        width={25}
                                                        height={25}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 fw-semibold"
                                                        style={{ color: "#314862" }}
                                                    >
                                                        Dedicated Counselor
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    Ask career-related questions anytime via chat
                                                </p>
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={Lock}
                                                        alt="compass"
                                                        width={25}
                                                        height={25}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 fw-semibold"
                                                        style={{ color: "#314862" }}
                                                    >
                                                        Step-by-Step College Admission Plan
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    End-to-End guidance & support for upto 7 college
                                                    applications
                                                </p>
                                            </div>
                                        </div>
                                    </CardBody>
                                    <CardFooter className="pt-2 pb-1">
                                        <div className="d-flex justify-content-between  align-items-center">
                                            <h5
                                                className="py-1 fw-semibold pt-2 box-button-style"
                                            >
                                                Rs 2,100/-
                                            </h5>
                                            <MdArrowRightAlt className="align-self-center fs-2" />
                                            <div className="razorpay-button-container">
                                                <form id="razorpay-form-0">
                                                </form>
                                            </div>
                                        </div>
                                    </CardFooter>
                                </Card>
                            </Col>
                            <Col xl="4" sm="10" md="6" lg="4" className="pointer">
                                <Card onClick={() => toggle(3)} className={`h-100 ${activeTab === 3 ? "active-tab" : ""}`}>
                                    <CardBody>
                                        <CardTitle
                                            tag="h5"
                                            className="box-header-style text-center pb-3 border-bottom"
                                        >
                                            Career Path Pro
                                        </CardTitle>
                                        <div className="justify-content-center mb-4 d-flex">
                                            <CardText
                                                className="fw-semibold align-self-center"
                                                tag="h3"
                                            >
                                                Rs 4999
                                            </CardText>
                                            <img className="ms-4" height={60} width={60} alt="know_image" src={career_image} />
                                        </div>
                                        <div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={compass}
                                                        alt="compass"
                                                        width={25}
                                                        height={25}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 pricing_title fw-semibold"
                                                    >
                                                        Career Exploration
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    Access well-researched content on careers, colleges,
                                                    courses, exams & scholarships
                                                </p>
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={assessment}
                                                        alt="compass"
                                                        width={25}
                                                        height={25}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 pricing_title fw-semibold"
                                                    >
                                                        Career Assessment
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    3-dimensional assessment covering 16 factors in
                                                    Aptitude, Personality & Interest
                                                </p>
                                            </div>

                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={session_icon}
                                                        alt="compass"
                                                        width={25}
                                                        height={25}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 pricing_title fw-semibold"
                                                    >
                                                        10 Live Weekly Career Class
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    Weekly live group class by top industry
                                                    professionals & college alumni
                                                </p>
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={call}
                                                        alt="compass"
                                                        width={25}
                                                        height={25}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 pricing_title fw-semibold"
                                                    >
                                                        3 Follow-Up Calls
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    15-min session or call to answer your queries
                                                </p>
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={parent_call}
                                                        alt="compass"
                                                        width={35}
                                                        height={35}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 pricing_title fw-semibold"
                                                    >
                                                        30-Min Parent Guidance Call
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    Discuss career options with an expert
                                                </p>
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={session_icon}
                                                        alt="compass"
                                                        width={25}
                                                        height={25}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 pricing_title fw-semibold"
                                                    >
                                                        Two: 1-on-1 Expert Career Session
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    One counselling session of 45 minutes to help in
                                                    understanding yourself & suitable career pathways
                                                </p>
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={counseller}
                                                        alt="compass"
                                                        width={25}
                                                        height={25}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 pricing_title fw-semibold"
                                                    >
                                                        Dedicated Counselor
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    Ask career-related questions anytime via chat
                                                </p>
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={Lock}
                                                        alt="compass"
                                                        width={25}
                                                        height={25}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 fw-semibold"
                                                        style={{ color: "#314862" }}
                                                    >
                                                        Step-by-Step College Admission Plan
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    End-to-End guidance & support for upto 7 college
                                                    applications
                                                </p>
                                            </div>
                                        </div>
                                    </CardBody>
                                    <CardFooter className="pt-2 pb-1">
                                        <div className="d-flex justify-content-between  align-items-center">
                                            <h5
                                                className="py-1 fw-semibold pt-2 box-button-style"
                                            >
                                                Rs 4,999/-
                                            </h5>
                                            <MdArrowRightAlt className="align-self-center fs-2" />
                                            <div className="razorpay-button-container">
                                                <form id="razorpay-form-2">
                                                </form>
                                            </div>
                                        </div>
                                    </CardFooter>
                                </Card>
                            </Col>
                            <Col className="pointer " xl="4" sm="10" md="6" lg="4">
                                <Card onClick={() => toggle(4)} className={`h-100 ${activeTab === 4 ? "active-tab" : ""}`}>
                                    <CardBody>
                                        <CardTitle
                                            tag="h5"
                                            className="box-header-style text-center pb-3 border-bottom"
                                        >
                                            Admission Path Pro
                                        </CardTitle>
                                        <div className="justify-content-center mb-4 d-flex">
                                            <CardText
                                                className="fw-semibold align-self-center"
                                                tag="h3"
                                            >
                                                Rs 9999
                                            </CardText>
                                            <img className="ms-4" height={60} width={60} alt="know_image" src={admission_image} />
                                        </div>
                                        <div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={compass}
                                                        alt="compass"
                                                        width={25}
                                                        height={25}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 pricing_title fw-semibold"
                                                    >
                                                        Career Exploration
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    Access well-researched content on careers, colleges,
                                                    courses, exams & scholarships
                                                </p>
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={assessment}
                                                        alt="compass"
                                                        width={25}
                                                        height={25}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 pricing_title fw-semibold"
                                                    >
                                                        Career Assessment
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    3-dimensional assessment covering 16 factors in
                                                    Aptitude, Personality & Interest
                                                </p>
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={session_icon}
                                                        alt="compass"
                                                        width={25}
                                                        height={25}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 pricing_title fw-semibold"
                                                    >
                                                        Unlimited Live Weekly Career Class
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    Weekly live group class by top industry
                                                    professionals & college alumni
                                                </p>
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={call}
                                                        alt="compass"
                                                        width={25}
                                                        height={25}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 pricing_title fw-semibold"
                                                    >
                                                        5 Personalized Follow-Up Calls
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    30-min session or call to answer your queries
                                                </p>
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={parent_call}
                                                        alt="compass"
                                                        width={35}
                                                        height={35}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 pricing_title fw-semibold"
                                                    >
                                                        60-Min Parent Guidance Call
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    Discuss career options with an expert
                                                </p>
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={session_icon}
                                                        alt="compass"
                                                        width={25}
                                                        height={25}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 pricing_title fw-semibold"
                                                    >
                                                        Four: 1-on-1 Expert Career Session
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    Three counselling session of 45 minutes to help in
                                                    understanding yourself & suitable career pathways
                                                </p>
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={counseller}
                                                        alt="compass"
                                                        width={25}
                                                        height={25}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 pricing_title fw-semibold"
                                                    >
                                                        Dedicated Counselor
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    Ask career-related questions anytime via <b>Call</b>
                                                </p>
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={admissions}
                                                        alt="compass"
                                                        width={25}
                                                        height={25}
                                                    />
                                                    &nbsp;&nbsp;
                                                    <h6
                                                        className="mb-1 pricing_title fw-semibold"
                                                    >
                                                        Step-by-Step College Admission Plan
                                                    </h6>
                                                </div>
                                                <p
                                                    className="mt-1"
                                                    style={{ color: "rgb(49 72 98 / 60%)" }}
                                                >
                                                    End-to-End guidance & support for upto 7 college
                                                    applications
                                                </p>
                                            </div>
                                        </div>
                                    </CardBody>
                                    <CardFooter className="pt-2 pb-1 ">
                                        <div className="d-flex justify-content-between  align-items-center">
                                            <h5
                                                className="py-1 fw-semibold pt-2 box-button-style"
                                            >
                                                Rs 9,999/-
                                            </h5>
                                            <MdArrowRightAlt className="align-self-center fs-2" />
                                            <div className="razorpay-button-container">
                                                <form id="razorpay-form-3">
                                                </form>
                                            </div>
                                        </div>
                                    </CardFooter>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
            {/* pricing */}
            {/* <Container fluid>
                <Row className="justify-content-center pt-4">
                    <Col xs="12" lg="12" xl="12" xxl="8">
                        <Row className="d-flex justify-content-center programs rounded-4  pt-5  g-4">
                            <Col className="mb-2 g-0" xs="12">
                                <div className="centerAlign">
                                    <div className="row p-sm-5 p-3">
                                        <div className="borderr col-lg-8 my-auto ">
                                            <h3> Book a 30-min Consultation With Our Expert</h3>
                                            <p>Our expert career advisors will assess your current standing and guide you towards the next steps, empowering you to plan your career strategically and turn your dreams and aspirations into reality.</p>
                                        </div>
                                        <div class="col-lg-4 text-center">
                                            <h2 className="fw-semibold">
                                                <small className="align-top fw-semibold">Rs</small> <span className="fw-semibold">99/-</span>
                                                <div className="align-bottom fw-semibold">Per Student</div>
                                            </h2>

                                            <div className="d-flex justify-content-center"> <br />
                                                <div className="d-flex justify-content-between align-items-sm-start align-items-center">
                                                    <div className="razorpay-button-container">
                                                        <form id="razorpay-form-1">
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <>
                                <div class="comparison p-0">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th className="tl"></th>
                                                <th vlassName="compare-heading">
                                                    <b className="fw-semibold"> Know Your Self</b>
                                                </th>
                                                <th className="compare-heading">
                                                    <b className="fw-semibold"> Career Path Pro</b>
                                                </th>
                                                <th className="compare-heading">
                                                    <b className="fw-semibold">Admission Path Pro</b>
                                                </th>
                                            </tr>
                                            <tr>
                                                <th><h4 className="text-white fw-semibold" style={{ position: 'relative', top: "-15px" }}>PACKAGE <br /> FEATURES</h4></th>
                                                <th className="price-info">
                                                    <div className="price-now"><b>₹<span className="fw-semibold">2,100</span></b><div style={{ fontSize: "9px" }}> Per Student</div></div>
                                                    <div className="razorpay-button-container mt-3">
                                                        <form id="razorpay-form-0">
                                                        </form>
                                                    </div>
                                                </th>
                                                <th className="price-info">
                                                    <div className="price-now"><b>₹<span className="fw-semibold">4,999</span></b><div style={{ fontSize: "9px" }}>Per Student</div></div>
                                                    <div className="razorpay-button-container mt-3">
                                                        <form id="razorpay-form-2">
                                                        </form>
                                                    </div>
                                                </th>
                                                <th className="price-info">
                                                    <div className="price-now"><b>₹<span className="fw-semibold">9,999</span></b><div style={{ fontSize: "9px" }}>Per Student</div></div>
                                                    <div className="razorpay-button-container mt-3">
                                                        <form id="razorpay-form-3">
                                                        </form>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td></td>
                                                <td colspan="3" className="table-main-font">What you get</td>
                                            </tr>
                                            <tr className="compare-row">
                                                <td className="table-main-font">What you get</td>
                                                <td className="td-big-para">Perfect Education Options: Subjects, Stream, Degree &amp; Specialization</td>
                                                <td className="td-big-para">Perfect Education &amp; Job Options: Subjects, Stream, Degree, Specialization &amp; Related Job Options</td>
                                                <td className="td-big-para">Perfect Education &amp; Job Options with Career Strategy: All Questions Answered!</td>
                                            </tr>
                                            <tr>
                                                <td>&nbsp;</td>
                                                <td colspan="3" className="table-main-font">Career Exploration</td>
                                            </tr>
                                            <tr>
                                                <td className="table-main-font"> Career Exploration</td>
                                                <td><span className="tickgreen">✔</span></td>
                                                <td><span className="tickgreen">✔</span></td>
                                                <td><span className="tickgreen">✔</span></td>
                                            </tr>
                                            <tr>
                                                <td>&nbsp;</td>
                                                <td colspan="3" className="table-main-font">Career Assessment</td>
                                            </tr>
                                            <tr className="compare-row">
                                                <td className="table-main-font"> Career Assessment</td>
                                                <td><span className="tickgreen">✔</span></td>
                                                <td><span className="tickgreen">✔</span></td>
                                                <td><span className="tickgreen">✔</span></td>
                                            </tr>
                                            <tr>
                                                <td>&nbsp;</td>
                                                <td colspan="3" className="table-main-font">Live Weekly Career Class</td>
                                            </tr>
                                            <tr>
                                                <td className="table-main-font">Live Weekly Career Class</td>
                                                <td><span>5</span></td>
                                                <td><span>10</span></td>
                                                <td><span>Unlimited</span></td>
                                            </tr>
                                            <tr>
                                                <td>&nbsp;</td>
                                                <td colspan="3" className="table-main-font">Follow-Up Call</td>
                                            </tr>
                                            <tr className="compare-row">
                                                <td className="table-main-font">Follow-Up Call</td>
                                                <td><span>1</span></td>
                                                <td><span>3</span></td>
                                                <td><span>5</span></td>
                                            </tr>
                                            <tr>
                                                <td>&nbsp;</td>
                                                <td colspan="3" className="table-main-font">Parent Guidance Call</td>
                                            </tr>
                                            <tr>
                                                <td className="table-main-font">Parent Guidance Call</td>
                                                <td><span>15-Min</span></td>
                                                <td><span>30-Min</span></td>
                                                <td><span>60-Min</span></td>
                                            </tr>
                                            <tr>
                                                <td>&nbsp;</td>
                                                <td colspan="3" className="table-main-font">1-on-1 Expert Career Session</td>
                                            </tr>
                                            <tr className="compare-row">
                                                <td className="table-main-font">1-on-1 Expert Career Session</td>
                                                <td><span className="tickred">❌</span></td>
                                                <td><span>1</span></td>
                                                <td><span>3</span></td>
                                            </tr>
                                            <tr>
                                                <td>&nbsp;</td>
                                                <td colspan="3" class="table-main-font">Dedicated Counselor</td>
                                            </tr>
                                            <tr>
                                                <td class="table-main-font">Dedicated Counselor</td>

                                                <td><span className="tickred">❌</span></td>
                                                <td><span className="tickgreen">✔</span></td>
                                                <td><span className="tickgreen">✔</span></td>
                                            </tr>
                                            <tr>
                                                <td>&nbsp;</td>
                                                <td colspan="3" class="table-main-font">Step-by-Step College Admission Plan</td>
                                            </tr>
                                            <tr className="compare-row">
                                                <td className="table-main-font"> Step-by-Step College Admission Plan</td>
                                                <td><span className="tickred">❌</span></td>
                                                <td><span className="tickred">❌</span></td>
                                                <td><span className="tickgreen">✔</span></td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>
                            </>
                        </Row>
                    </Col>
                </Row>
            </Container> */}
            {/* second sec outCome */}
            <Container className="d-none d-sm-block">
                <Row className="justify-content-center pt-4">
                    <Col xs="12" className="text-center mb-5 fs-5 mt-5">
                        Need additional Sessions? avail it at ₹1500 per session
                    </Col>
                    <Col xxl={11}>
                        <Row className="d-flex pt-3">
                            {/* Left Section */}
                            <Col md="3" lg={1}>
                                <div className="d-flex pb-md-0 pb-4">
                                    <img src={Outcome} alt="Outcome" />
                                    <div className="outcome_text  ps-4">Outcome</div>
                                </div>
                            </Col>

                            {/* Right Section */}
                            <Col md={9} className="mx-auto ps-xxl-5">
                                <Row>
                                    <Col sm={4}>
                                        <Row>
                                            <div className="d-flex">
                                                <FontAwesomeIcon className="me-3 check_icon fw-semibold mt-1" icon={faCheck} />
                                                <span className="outcome_desc">
                                                    Absolute clarity on your Areas of interest, Aptitude Level, Personality Type, and your Strength
                                                </span>
                                            </div>
                                            <div className="d-flex mt-sm-5">
                                                <FontAwesomeIcon className="me-3 check_icon mt-1" icon={faCheck} />
                                                <span className="outcome_desc">Recommendation of suitable Career Paths.</span>
                                            </div>
                                        </Row>
                                    </Col>

                                    <Col sm={4}>
                                        <Row>
                                            <div className="d-flex mt-sm-0 mt-3">
                                                <FontAwesomeIcon className="me-3 check_icon  mt-1" icon={faCheck} />
                                                <span className="outcome_desc">
                                                    Absolute clarity on your Areas of interest, Aptitude Level, Personality Type, and your Strength
                                                </span>
                                            </div>
                                            <div className="d-flex mt-sm-5">
                                                <FontAwesomeIcon className="me-3 check_icon mt-1" icon={faCheck} />
                                                <span className="outcome_desc">Recommendation of suitable Career Paths.</span>
                                            </div>
                                            <div className="d-flex mt-sm-5">
                                                <FontAwesomeIcon className="me-3 check_icon mt-1" icon={faCheck} />
                                                <span className="outcome_desc">Absolute clarity on your course, colleges, backup colleges.</span>
                                            </div>
                                        </Row>
                                    </Col>

                                    <Col sm={4}>
                                        <Row>
                                            <div className="d-flex mt-sm-0 mt-3">
                                                <FontAwesomeIcon className="me-3 check_icon mt-1" icon={faCheck} />
                                                <span className="outcome_desc">
                                                    Absolute clarity on your course, colleges, backup colleges.
                                                </span>
                                            </div>
                                            <div className="d-flex mt-sm-5">
                                                <FontAwesomeIcon className="me-3 check_icon mt-1" icon={faCheck} />
                                                <span className="outcome_desc">
                                                    Entire college application process including help in application form filling.
                                                </span>
                                            </div>
                                            <div className="d-flex mt-sm-5">
                                                <FontAwesomeIcon className="me-3 check_icon mt-1" icon={faCheck} />
                                                <span className="outcome_desc">
                                                    Our commitment to be there with you until you get an admission offer letter from an Indian college
                                                </span>
                                            </div>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
            {/* contact */}
            <GetStarted />
        </>
    );
}

export default PricingPlan;
